import React from "react"
import { Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage, useIntl } from "react-intl"
import { STATE_NAME_TO_ABBREVIATION } from "#/utils/UsaStateOptions"

export function VirtualServiceRestrictionNotice({
  virtualServicesNotAvailableIn
}: {
  virtualServicesNotAvailableIn?: string[]
}): JSX.Element | null {
  const intl = useIntl()
  if (!virtualServicesNotAvailableIn?.length) return null

  const abbreviations = [...virtualServicesNotAvailableIn]
    .sort((a, b) => a.localeCompare(b))
    .map((state) => STATE_NAME_TO_ABBREVIATION[state] ?? state)
  const formattedStates = intl.formatList(abbreviations, { type: "unit" })

  return (
    <Typography variant="body2" color="secondary" sx={{ wordBreak: "break-word" }}>
      <FormattedMessage
        defaultMessage="* Not available in {states}."
        values={{
          states: formattedStates
        }}
      />
    </Typography>
  )
}
